// extracted by mini-css-extract-plugin
export default {"third_section_container":"THIRD_SECTION_third_section_container__EVWUU","placement":"THIRD_SECTION_placement__MHtC9","section_container":"THIRD_SECTION_section_container__HF5yG"};